// Passage de session vers app.revertai.io.
//
// L'authentification se fait sur revertai.io (login, invitation) mais l'app vit
// sur app.revertai.io : deux origines, donc deux localStorage. La session ne
// traverse pas toute seule. Le relais est /auth/callback, qui lit les jetons
// dans le hash — un hash n'est jamais envoyé au serveur ni écrit dans les logs.

import { supabase } from './supabase';
import { APP_ORIGIN, IS_APP_DOMAIN, goToApp } from './domain';

/**
 * Emmène l'utilisateur fraîchement authentifié dans l'app, en transportant la
 * session si on est sur une autre origine. Sans session, on redirige quand même :
 * l'AuthGuard fera son travail.
 */
export async function handOffToApp(path = '/home'): Promise<void> {
  const { data: { session } } = await supabase.auth.getSession();

  if (IS_APP_DOMAIN || !session) {
    goToApp(path);
    return;
  }

  const params = new URLSearchParams({
    access_token: session.access_token,
    refresh_token: session.refresh_token,
    next: path,
  });
  window.location.href = `${APP_ORIGIN}/auth/callback#${params.toString()}`;
}
